import { Middleware } from 'redux';


/**
 * A middleware function that does nothing.
 */
export const noOpMiddleware: Middleware<any> = state => next => action => next(action);
